<template>
  <div
    @focus="handleFocus"
    @focusout="handleFocusOut"
    tabindex="0"
    v-if="isSidebarActiveLocal"
    ref="frame"
    :class="isSidebarActiveLocal ? 'active' : ''" class="res-product-pop-cont">
    <div tabindex="1" v-if="step === 0">
      <div class="reservation-popup">
        <div class="reservation-header">
          <h2>Make a Reservation</h2>
        </div>
        <div class="reservation-form">
          <div class="reservation-option">
            <div class="reservation-option-section">
              <label>Party Size</label>
            </div>
            <div class="reservation-option-section">
              <select v-model="person">
                <option value="2">2 People</option>
                <option value="3">3 People</option>
                <option value="4">4 People</option>
                <option value="5">5 People</option>
                <option value="6">6 People</option>
                <option value="7">7 People</option>
                <option value="8">8 People</option>
              </select>
            </div>
          </div>
          <div class="reservation-option two-col">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <label>Date</label>
              </div>
              <div class="reservation-option-section">
<!--                <input type="date" v-model="date" />-->
                <datepicker ref="datepicker" v-model="date"></datepicker>
                <div @click.prevent.stop="show_calendar = true">
                  <select class="date-text" disabled>
                    <option>{{ formatDate(date) }}</option> <!-- Nov 11, 2022 -->
                  </select>
                </div>
              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <label>Time</label>
              </div>
              <div class="reservation-option-section">
                <vue-timepicker format="hh:mm A" v-model="time" :minute-interval="15"></vue-timepicker>
              </div>
            </div>
          </div>

          <div v-if="available_hours"  class="reservation-option">
            <div class="reservation-option-section">
              <label>Available spots</label>
            </div>
            <div class="reservation-option-section available-spots" v-if="available_hours.length > 0">
              <div v-for="seating in available_hours"
                   @click="selected_booking = seating"
                   :key="seating._id"
                   class="reservation-seating">
                {{formatTime2(seating.bookDate)}}
              </div>
            </div>
            <div v-else>
              <div class="reservation-seating">
                No seats at that time
              </div>
            </div>
          </div>
          <div class="reservation-button" v-if="!check" @click="checkAvailability">Check Availability</div>
          <div class="reservation-button" v-else @click="makeReservations">Make Reservation</div>
        </div>
      </div>
    </div>
    <div tabindex="1" v-else-if="step === 1 && selected_booking">
      <div class="reservation-popup">
        <div class="reservation-header">
          <h2>Reservation Details</h2>
        </div>
        <div class="reservation-details-cont">
          <div class="reservation-res"><h2>{{ restaurantName }}</h2></div>
          <div class="reservation-details">
            <div class="res-det"><i class="far fa-calendar"></i>{{ formatDate(selected_booking.bookDate) }}</div>
            <div class="res-det"><i class="far fa-clock"></i> {{ formatTime2(selected_booking.bookDate) }}</div>
            <div class="res-det"><i class="far fa-user"></i> {{ person }} People </div>
          </div>

          <div class="reservation-res"><h2>Seating</h2></div>
          <div class="reservation-option-section flex mb-4" v-if="selected_booking.seatings.length > 0">
            <div v-for="seating in selected_booking.seatings"
                 :key="seating._id"
                 class="reservation-seating">
              <b-form-radio :value="seating._id"
                            v-model="selected_seating"
                            name="seating"
                            ref="seating"
                            data-vv-as="Seating"
                            v-validate="'required'">{{seating.type}} <br> {{seating.seats}} seats</b-form-radio>

            </div>

          </div>

          <span v-show="errors.has('seating')" class="text-danger">Seating is required</span>
        </div>
        <div class="reservation-form">
          <div class="reservation-option two-col complete">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input
                  type="text"
                  v-model="name"
                  placeholder="First Name"
                  name="name"
                  ref="name"
                  data-vv-as="First Name"
                  v-validate="'required'">

                <span v-show="errors.has('name')" class="text-danger">First Name is required</span>

              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input type="text"
                       v-model="lastname"
                       placeholder="Last Name"
                       name="lastname"
                       ref="lastname"
                       data-vv-as="Last Name"
                       v-validate="'required'">

                <span v-show="errors.has('lastname')" class="text-danger">Last Name is required</span>
              </div>
            </div>
          </div>
          <div class="reservation-option two-col complete">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <phone-mask-input
                  v-model="phone"
                  @onValidate="validatePhone"
                  defaultCountry="us"
                  wrapperClass="relative"
                  inputClass="vs-input-no-border py-3 px-2 mb-0"
                  v-validate="'required'"

                  name="Phone Number"
                  ref="phone"
                  data-vv-as="Phone Number"
                />
                <span v-show="errors.has('phone')" class="text-danger">Phone Number is required</span>
              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <input type="email"
                       placeholder="Email"
                       v-model="email"
                       name="email"
                       ref="email"
                       data-vv-as="Email"
                       v-validate="'required'">

                <span v-show="errors.has('email')" class="text-danger">Email is required</span>
              </div>
            </div>
          </div>
          <div class="reservation-option">
            <div class="reservation-column">
              <div class="reservation-option-section">
                <label>Select an Occasion (Optional)</label>
              </div>
              <div class="reservation-option-section">
                <select v-model="occasion">
                  <option value="-1">Occasion</option>
                  <option value="Birthday">Birthday</option>
                  <option value="Anniversary">Anniversary</option>
                  <option value="Date Night">Date Night</option>
                  <option value="Business Meal">Business Meal</option>
                  <option value="Celebration">Celebration</option>
                </select>
              </div>
            </div>
            <div class="reservation-column">
              <div class="reservation-option-section">
                <label>Special Request (Optional)</label>
              </div>
              <div class="reservation-option-section">
                <textarea v-model="note"></textarea>
              </div>
            </div>
          </div>
          <div class="reservation-button" @click="book">Complete Reservation</div>
          <div class="reservation-terms">
            <p>
              By clicking “Complete Reservation” you agree to the <a href="/terms-of-services" target="_blank">Turkish Restaurant Terms of Service</a> and <a href="/privacy-policy" target="_blank">Privacy Policy</a>. Standard text message rates may apply. You may opt out of receiving text messages at any time.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div tabindex="1" v-else-if="step === 2 && booking_result">
      <div class="reservation-popup">
        <div class="reservation-header">
          <h2>Reservation Completed</h2>
        </div>
        <div class="reservation-completed">
          <i class="far fa-calendar-check"></i>
          <h2>Your Reservation Completed Successfuly!</h2>
          <p>We sent details of this reservartion to your email.<br><br> {{restaurantName}} may contact you about this reservation, so please ensure your email and phone number are up to date.</p>

          <div class="reservation-button" @click="isSidebarActiveLocal = false">Close</div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import axios from '../../axios'
import Datepicker from 'vuejs-datepicker'
import VueTimepicker from 'vue2-timepicker'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'
import PhoneMaskInput from 'vue-phone-mask-input'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    dataProp: {
      type: Object,
      default: () => {
      }
    },
    restaurantName: {
      type: String
    },
    apiKey: {
      type: String
    }
  },
  components: {
    PhoneMaskInput,
    VuePerfectScrollbar,
    Datepicker,
    VueTimepicker,
    moment,
    axios
  },
  data () {
    return {
      step: 0,
      date: new Date(),
      time: '',
      person: 2,
      available_hours: null,
      check: false,
      checkPhone: false,
      show_calendar: false,
      selected_booking: null,
      selected_seating: null,
      name: '',
      lastname: '',
      phone: '',
      email: '',
      occasion: '-1',
      note: '',
      booking_result: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.date = new Date()// this.formatDate(Date.now())
      this.time = this.formatTime(Date.now())
    })
  },
  beforeDestroy () {
    this.isSidebarActiveLocal = false
  },
  watch: {
    phone () {
      if (this.checkPhone) {
        if (this.formatPhoneNumber(this.phone)) {
          this.errors.remove('phone')
        } else if (!this.errors.has('phone')) {
          this.errors.add({
            field: 'phone',
            msg: 'Phone field is required'
          })
        }
      } else {
        this.checkPhone = true
      }
    },
    date () {
      if (this.show_calendar) {
        this.show_calendar = false
      }
      this.check = false
    },
    time () {
      this.check = false
    },
    show_calendar (val) {
      if (val) {
        setTimeout(() => {
          this.$refs.datepicker.showCalendar()
        }, 200)
      }
    },
    isSidebarActive (val) {
      if (!val) {
        this.reset()
        return
      }

      this.date = new Date()// this.formatDate(Date.now())
      this.time = this.formatTime(Date.now())
      // const {name, id, price, complete_your_meal, description, restaurant_id, size, section, size_id, section_id, hasModifiers, quantity, photoUrl} = JSON.parse(JSON.stringify(this.dataProp))
      return true
    },
    selected_booking () {
      if (this.selected_booking) {
        this.step = 1
      } else {
        this.step = 0
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          this.$validator.reset()
        }
      }
    },
    endDate () {
      const date_q = `${this.formatDate(this.date)} ${this.time}`
      const result = moment.utc(date_q, 'MMM DD, YYYY hh:mm A').toISOString()
      return result
    }
  },
  methods: {
    validatePhone () {
      return !!this.formatPhoneNumber(this.phone)
    },
    formatPhoneNumber (phoneNumberString) {
      const cleaned = (phoneNumberString).replace(/\D/g, '')
      const match = cleaned.match(/^(\d{1})(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return `+${match[1]} (${match[2]}) ${match[3]}-${match[4]}`
      }
      return null
    },
    book () {
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.selected_booking) {
            const payload = {
              ...this.selected_booking,
              seatings: [this.selected_seating],
              occasion: this.occasion !== '-1' ? this.occasion : '',
              customer: {
                name: this.name,
                lastname: this.lastname,
                email: this.email,
                phone: this.formatPhoneNumber(this.phone),
                note: this.note,
                seats: this.person
              }
            }
            this.bookDate(payload)
          }
        }
      })
    },
    makeReservations () {},
    reset () {
      this.selected_booking = null
      this.time = ''
      this.date = ''
      this.name = ''
      this.lastname = ''
      this.email = ''
      this.phone = ''
      this.occasion = '-1'
      this.note = ''
      this.selected_seating = null
      this.available_hours = null
    },
    bookDate (payload) {
      this.$vs.loading()
      const key = this.apiKey
      axios
        .post('https://reservations.authorizelocal.com/api/book', payload, {
          headers:{
            'Content-Type': 'application/json',
            key
          }
        })
        .then(response => {
          if (response.data.status) {
            this.booking_result = response.data.data
            this.step = 2
            this.$vs.notify({
              title: response.data.message,
              text: 'please check your inbox',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$vs.loading.close()
          } else {
            this.$vs.notify({
              title: response.data.message,
              text: 'please check your inbox',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            })
            this.$vs.loading.close()
          }
        }).catch(e => {
          this.$vs.notify({
            title: e.message.responseCode,
            text: e.message.response,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
          this.$vs.loading.close()
        })
    },
    checkAvailability () {
      const payload = {
        date: this.endDate,
        person: this.person
      }
      const key = this.apiKey
      axios
        .get('https://reservations.authorizelocal.com/api/reservations/check', {
          params: payload,
          headers:{
            'Content-Type': 'application/json',
            key
          }
        })
        .then(response => {
          if (response.data.status) {
            this.available_hours = response.data.data.available_dates
            // this.check = true
          }
        })
    },
    formatDate (date) {
      const result = moment.utc(date).format('MMM DD, YYYY')
      return result
    },
    formatTime (date) {
      const result = moment.utc(date).add(2, 'hours').format('hh:00 A')
      return result
    },
    formatTime2 (date) {
      const result = moment.utc(date).format('hh:mm A')
      return result
    },
    handleFocus () {
      // do something here
      this.isSidebarActiveLocal = false
    },
    handleFocusOut () {
      // do something here
    }
  }
}
</script>
